import { ReactNode } from 'react';
interface HeroContainerProps {
  children: ReactNode;
}

export const HeroContainer = ({ children }: HeroContainerProps) => {
  return <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{children}</div>;
};
